// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".a8dbc61c3bc153c1f1b9ce2e25d2e06e.js";
};